import { render, staticRenderFns } from "./Rosterlook.vue?vue&type=template&id=63a7df47"
import script from "./Rosterlook.vue?vue&type=script&lang=js"
export * from "./Rosterlook.vue?vue&type=script&lang=js"
import style0 from "./Rosterlook.vue?vue&type=style&index=0&id=63a7df47&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports